<div class="dialog-content-wrapper">
    <mat-toolbar class="mat-primary m-0">
        <mat-toolbar-row
            fxFlex
            fxLayout="row"
            fxLayoutAlign="space-between center"
        >
            <span class="title dialog-title text-truncate"
                >{{ data.editar ? "Editar" : "Nuevo" }} contratista</span
            >
            <button
                mat-icon-button
                (click)="dialogRef.close()"
                aria-label="Close dialog"
            >
                <mat-icon>close</mat-icon>
            </button>
        </mat-toolbar-row>
    </mat-toolbar>

    <mat-dialog-content class="p-16 pb-0 m-0">
        <form class="form" [formGroup]="formContratista" autocomplete="off">
            <mat-form-field class="full-width" *ngIf="!data.editar">
                <mat-label>Rut </mat-label>
                <input matInput type="text" formControlName="rut" required />
                <mat-hint>Rut con formato 12345678-9</mat-hint>
                <mat-error *ngIf="rut.hasError('required')">
                    Debe ingresar el rut del contratista
                </mat-error>
                <mat-error *ngIf="rut.hasError('digitoVerificador')">
                    Debe ingresar un rut válido
                </mat-error>
            </mat-form-field>

            <mat-form-field class="full-width">
                <mat-label>Nombres </mat-label>
                <input
                    matInput
                    type="text"
                    formControlName="nombres"
                    required
                />

                <mat-error *ngIf="nombres.hasError('required')">
                    Debe ingresar los nombres del contratista
                </mat-error>
                <mat-error *ngIf="nombres.hasError('minlength')">
                    El nombre debe tener al menos 3 caracteres
                </mat-error>
                <mat-error *ngIf="nombres.hasError('maxlength')">
                    El nombre no puede ser mayor a 100 caracteres
                </mat-error>
            </mat-form-field>
            <mat-form-field class="full-width">
                <mat-label>Apellidos </mat-label>
                <input
                    matInput
                    type="text"
                    formControlName="apellidos"
                    required
                />

                <mat-error *ngIf="apellidos.hasError('required')">
                    Debe ingresar los apellidos del contratista
                </mat-error>
                <mat-error *ngIf="apellidos.hasError('minlength')">
                    El apellido debe tener al menos 3 caracteres
                </mat-error>
                <mat-error *ngIf="apellidos.hasError('maxlength')">
                    El apellido no puede ser mayor a 100 caracteres
                </mat-error>
            </mat-form-field>

            <mat-form-field class="full-width">
                <mat-label>Banco</mat-label>
                <mat-select formControlName="banco" required>
                    <mat-option *ngFor="let b of data.bancos" [value]="b.id">
                        {{ b.nombre }}
                    </mat-option>
                </mat-select>

                <mat-error *ngIf="banco.hasError('required')">
                    Debe seleccionar un banco
                </mat-error>
            </mat-form-field>

            <mat-form-field class="full-width">
                <mat-label>Tipo de cuenta</mat-label>
                <mat-select formControlName="tipoCuenta" required>
                    <mat-option
                        *ngFor="let tipoCuenta of data.tiposCuenta"
                        [value]="tipoCuenta.id"
                    >
                        {{ tipoCuenta.descripcion }}
                    </mat-option>
                </mat-select>

                <mat-error *ngIf="tipoCuenta.hasError('required')">
                    Debe seleccionar un tipo de cuenta
                </mat-error>
            </mat-form-field>

            <mat-form-field class="full-width">
                <mat-label>Nro. de cuenta </mat-label>
                <input
                    matInput
                    type="text"
                    formControlName="nroCuenta"
                    required
                />

                <mat-error *ngIf="nroCuenta.hasError('required')">
                    Debe ingresar el Nro. de cuenta
                </mat-error>
                <mat-error *ngIf="nroCuenta.hasError('minlength')">
                    El numero de cuenta debe tener al menos 3 caracteres
                </mat-error>
                <mat-error *ngIf="nroCuenta.hasError('maxlength')">
                    El numero de cuenta no puede ser mayor a 20 caracteres
                </mat-error>
            </mat-form-field>
            <mat-form-field class="full-width">
                <mat-label>Correo Electrónico </mat-label>
                <input matInput type="text" formControlName="correo" required />
                <mat-error *ngIf="correo.errors">
                    Debe ingresar un correo con el formato correcto
                    xxxxx@yyyy.zz
                </mat-error>
            </mat-form-field>
        </form>
    </mat-dialog-content>
    <mat-dialog-actions
        class="m-0 p-16"
        fxLayout="row"
        fxLayoutAlign="end center"
    >
        <button mat-button mat-dialog-close>Cancelar</button>
        <button
            mat-raised-button
            color="accent"
            [mat-dialog-close]="formContratista.value"
            [disabled]="!formContratista.valid"
        >
            Guardar
        </button>
    </mat-dialog-actions>
</div>
